import { Box, Button, Container, FormLabel, Heading, Input ,Textarea, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const RequestPage = () => {
    const [name,setName]=useState();
    const [email,setEmail]=useState();
    const [course,setCourse]=useState();
  return (
    <Container h='92vh'>
        <VStack h='full' justifyContent={'center'} spacing='16'>
            <Heading children='Request A Course' />
            <form style={{width:'100%'}}>
                <Box my={'4'}>
                <FormLabel htmlFor='name' children='Your Name'/>
                <Input required id='name' value={name} onChange={(e)=>setName(e.target.value)} placeholder='name of course' type='text' focusBorderColor='yellow.500' />
                </Box>
                <Box my={'4'}>
                <FormLabel htmlFor='email' children='Email Address'/>
                <Input required id='email' value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='ok123@gmail.com' type='email' focusBorderColor='yellow.500' />
                </Box>
                <Box my={'4'}>
                <FormLabel htmlFor='course' children='course'/>
                <Textarea required id='course' value={course} onChange={(e)=>setCourse(e.target.value)} placeholder='details of the course' type='text' focusBorderColor='yellow.500' />
                </Box>
                <Button my='4' colorScheme={'yellow'} type='Submit'>Send course</Button>
                <Box my='4'>
                    See existing courses<Link to="/courses"><Button colorScheme={'yellow'} variant='link'>Here</Button></Link>
                </Box>
            </form>
        </VStack>
    </Container>
  )
}

export default RequestPage